<template>
  <v-data-table
    :headers="filteredHeaders"
    :items="itemsList"
    :search="search"
    :footer-props="{
      showFirstLastPage: true,
      showCurrentPage: true,
      itemsPerPageText: 'Rodyti po:',
      itemsPerPageAllText: 'visi',
      itemsPerPageOptions: itemsPerPageOptions,
    }"
    :hide-default-footer="hideFooter"
    :hide-default-header="true"
    :items-per-page="pageSize"
  >
    <template #top>
      <v-toolbar flat v-if="itemsList.length > 1">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label=""
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template #[`item.info`]="{ item }">
      <div class="migris-details-info">
        <v-row no-gutters>
          <v-col class="migris-details-header" cols="3">ILTU kodas</v-col>
          <v-col class="migris-details-header" cols="4"
            >Asmens kodas (Užsienio valstybėje)</v-col
          >
          <v-col class="migris-details-header" cols="5"
            >Kodą išdavusi valstybė</v-col
          >
        </v-row>

        <v-row
          no-gutters
          v-for="(personCode, person_index) in item.migris_details
            .foreignPersonCodeList"
          :key="`person-${person_index}`"
        >
          <v-col cols="3">{{
            person_index == 0 ? item.migris_details.iltuCode : ''
          }}</v-col>
          <v-col cols="4">{{
            personCode.foreignCode ? personCode.foreignCode : '-'
          }}</v-col>
          <v-col cols="5">{{
            personCode.foreignCountry ? personCode.foreignCountry : '-'
          }}</v-col>
        </v-row>

        <v-row no-gutters>
          <v-col class="migris-details-header" cols="3"
            >Dokumento numeris</v-col
          >
          <v-col class="migris-details-header" cols="3">Išdavimo data</v-col>
          <v-col class="migris-details-header" cols="3"
            >Išdavusi valstybė</v-col
          >
          <v-col class="migris-details-header" cols="3">Dokumento rūšis</v-col>
        </v-row>

        <v-row
          no-gutters
          v-for="(document, document_index) in item.migris_details
            .documentsList"
          :key="`document-${document_index}`"
        >
          <v-col cols="3">{{
            document.documentNo ? document.documentNo : '-'
          }}</v-col>
          <v-col cols="3">{{
            document.issueDate ? document.issueDate : '-'
          }}</v-col>
          <v-col cols="3">{{
            document.country ? document.country : '-'
          }}</v-col>
          <v-col cols="3">{{
            document.documentTypeTitle ? document.documentTypeTitle : '-'
          }}</v-col>
        </v-row>
      </div>
    </template>
    <template #[`item.actions`]="{ item }">
      <el-table-action :item="item" @selectItem="selectAsmuo(item)" />
    </template>
    <template slot="loading">
      Kraunasi...
    </template>
    <template slot="no-results">
      Duomenų nėra
    </template>
    <template slot="no-data">
      Duomenų nėra
    </template>
    <template #[`footer.page-text`]="props">
      Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
      {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ElAsmenysMigrisList',
  props: {
    asmenys: Array,
    tipas: String,
  },
  data() {
    return {
      search: null,
      itemsPerPageOptions: [5, 10, -1],
      pageSize: 5,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Info',
          align: 'start',
          value: 'info',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map(item => {
        if (item.migris_details.foreignPersonCodeList.length === 0) {
          item.migris_details.foreignPersonCodeList.push({
            foreignCode: null,
            foreignCountry: null,
          })
        }
        if (item.migris_details.documentsList.length === 0) {
          item.migris_details.documentsList.push({
            documentNo: null,
            issueDate: null,
            country: null,
            documentTypeTitle: null,
          })
        }

        let searchText = ''
        searchText += item.migris_details.iltuCode + '‡'

        item.migris_details.foreignPersonCodeList.forEach(element => {
          searchText += element.foreignCode + '‡' + element.foreignCountry + '‡'
        })
        item.migris_details.documentsList.forEach(element => {
          searchText +=
            element.documentNo +
            '‡' +
            element.issueDate +
            '‡' +
            element.country +
            '‡' +
            element.documentTypeTitle +
            '‡'
        })

        item.info = searchText

        item.canSelect = true
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 5
    },
    isFizinis() {
      return this.tipas === 'FIZ'
    },
  },
  methods: {
    selectAsmuo(item) {
      item.canSelect = false
      this.$emit('selectAsmuo', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.migris-details-info {
  .migris-details-header {
    margin-top: 0.3rem;
    font-weight: 400;
  }

  .col {
    margin-bottom: 0.3rem;
  }

  font-weight: 600;
}
</style>
